// import React, { useEffect, useState, useRef } from 'react';
import Header from '../components/header.jsx';
// Bootstrap removed - using Tailwind-only approach
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HomeSquare1, HomeSquare2, HomeSquare3, HomeSquare4, HomeSquare5, ThinContainer } from '../components/container.jsx';
import ContainerWrapper from '../components/containerwrapper.jsx';
import ContainerLayout from '../components/ContainerLayout.jsx';
import axios from 'axios';
import { useUserContext } from "../context/UserContext.jsx";
import PopupComponent from "../components/PopupComponent.jsx";
import Sidebar from "../components/Sidebar.jsx";
import {InteractionCallIcon, InteractionEmailIcon, InteractionEventIcon, InteractionTextIcon, InteractionSocMedIcon} from '@/components/icons/index.js'
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { toast } from "react-toastify";

// export async function getServerSideProps(context) {
//     const { req } = context;
//     console.log('Cookies:', req.headers.cookie);

//     const cookies = req.headers.cookie || '';
//     const parsedCookies = Object.fromEntries(
//         cookies.split('; ').map(c => c.split('='))
//     );

//     const userid = parsedCookies.userId || null;

//     // Redirect if no userid
//     // if (!userid) {
//     //     return {
//     //         redirect: {
//     //             destination: '/login',
//     //             permanent: false,
//     //         },
//     //     };
//     // }

//     return {
//         props: { userid },
//     };
// }

// export default function Home() {
//     return (
//         <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
//             <h1 className="text-4xl font-bold text-gray-800 mb-4">🚧 Dashboard Is Under Construction 🚧</h1>
//             <p className="text-lg text-gray-600">We’re working hard to bring this page to you soon. Please check back later!</p>
//         </div>
//     );
    // const [dashboardText, setDashboardText] = useState("Dashboard");
    // const [buttonText, setButtonText] = useState("Click Me");
    // const [userData, setUserData] = useState(null); // For storing fetched user data
    // const [pivotTable, setPivotTable] = useState(null); // For storing fetched user data
    // const [error, setError] = useState(null); 
    // const navigate = useNavigate();
    // const location = useLocation();
    // const { userId, partnerId } = useUserContext();
    // const [isOpen, setIsOpen] = useState(false);
    // const [view, setView] = useState("main"); // State to manage sidebar content (main or secondary)
    // const sidebarRef = useRef(null);

    // // Toggle the sidebar state
    // const toggleSidebar = () => {
    //     setIsOpen(!isOpen);
    // };


    // // Active link style
    // const activeStyle = {
    //     borderBottom: '3px solid yellow',
    //     fontWeight: 'bold',
    // };

    // // useEffect(() => {
    // //     // Retrieve userId from localStorage when component mounts
    // //     const storedUserId = localStorage.getItem("userId");
    // //     if (storedUserId) {
    // //         setUserId(storedUserId); // Set userId if found in localStorage
    // //     }
    // // }, []); // Empty dependency array ensures this runs once on mount

    
    
    // // // Redirect if no userid
    // // if (!{userId}) {
    // //     return {
    // //         redirect: {
    // //             destination: '/login',
    // //             permanent: false,
    // //         },
    // //     };
    // // }

    // // Close sidebar if user clicks outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
    //         setIsOpen(false); // Close the sidebar if click is outside
    //     }
    //     };

    //     if (isOpen) {
    //     document.addEventListener("mousedown", handleClickOutside);
    //     } else {
    //     document.removeEventListener("mousedown", handleClickOutside);
    //     }

    //     return () => {
    //     document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [isOpen]);

    // const showMainSidebar = () => setView("main");
    // const showSecondarySidebar = () => setView("secondary");

    // // Fetch data if userId is set
    // useEffect(() => {
    //     // if (!userId) return; // Prevent fetching if userId is not available yet
    //     // Redirect if no userid
    //     // if (!{userId}) {
    //     //     return {
    //     //         redirect: {
    //     //             destination: '/login',
    //     //             permanent: false,
    //     //         },
    //     //     };
    //     // }
    //     console.log({userId}?.userId)
        
    //     const userid = {userId}
    //     if ({userid} == null) {
    //         return <LoadingComponent />; // Or simply return null or a loading spinner
    //       }


    //     console.log({userid})
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get(`${import.meta.env.VITE_BASE_URL}/home`, {
    //                 params: { param: {userId}?.userId },
    //             });
    //             console.log("Full Response:", response);
    //             // setUserData(response.result); // Set userData after the fetch
    //             // Accessing the 'result' property in the response and ensuring it's an array
    //             const resultData = response.data?.result;
    //             console.log(resultData)
    //             const pivot_table = response.data?.pivot_table;
    //             const lead_count = response.data?.leadCount;
    //             const weekly_count = response.data?.weeklyCount;
    //             console.log(lead_count)

    //             setUserData(resultData); // Set userData as an array
    //             setPivotTable(pivot_table);
    //             // setPivotTable(lead_count);
    //             localStorage.setItem("userData", JSON.stringify(resultData));
    //             localStorage.setItem("pivotTable", JSON.stringify(pivot_table));
    //             localStorage.setItem("leadCount", JSON.stringify(lead_count));
    //             localStorage.setItem("weeklyCount", JSON.stringify(weekly_count));
    //             setError(null); // Clear any errors
    //         } catch (err) {
    //             setError(err.message); // Handle errors
    //         }
    //     };

    //     fetchData();
    // }, [userId]); // This effect runs whenever userId changes

    // if (!userData) {
    //     // Render a fallback or loading state if userData is null
    //     return (
    //         <div className="container">
    //             <h1>No User Found</h1>
    //         </div>
    //     );
    // }

    // return (
    //     <>
    //         <div className="sticky-top">
    //             <div className="sticky top-0 bg-white shadow">
    //                 <nav className="flex items-center justify-between p-4">
    //                     <div className="text-lg font-bold">
    //                         <a href="/home" className="flex items-center space-x-1">
    //                             <span>MoneyMatch</span> 
    //                             <b className="text-yellow-300">CSP</b>
    //                             <span>4.0</span>
    //                         </a>
    //                     </div>
    //                     <div className="flex space-x-6">
    //                         <Link 
    //                             to="/Home" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/lead_distribution' ? 'text-yellow-300 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Lead Distribution
    //                         </Link>
    //                         <Link 
    //                             to="/Planner" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/lead_inventory' ? 'text-indigo-600 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Lead Inventory
    //                         </Link>
    //                         <Link 
    //                             to="/Leads" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/accounts_distribution' ? 'text-indigo-600 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Accounts Distribution
    //                         </Link>
    //                         <Link 
    //                             to="/Analytics" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/accounts_inventory' ? 'text-indigo-600 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Accounts Inventory
    //                         </Link>
    //                         <Link 
    //                             to="/Sales Depository" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/opportunity_inventory' ? 'text-indigo-600 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Opportunity Inventory
    //                         </Link>
    //                         <Link 
    //                             to="/Admin" 
    //                             className={`hover:text-yellow-300 ${location.pathname === '/admin' ? 'text-indigo-600 font-semibold' : 'text-gray-700'}`}
    //                         >
    //                             Admin
    //                         </Link>
    //                     </div>
    //                 </nav>
    //             </div>


    //             <Container className="mt-0 mb-1 pt-4  bg-white shadow w-full max-w-[4000px]">
    //                 <Row className="align-items-center">
    //                 <div className="flex items-center justify-between pb-4 pt-1 ml-5 mr-5">
    //                     <p className="m-0"><b>Dashboard</b></p>
    //                     <button
    //                         onClick={() => setButtonText("Clicked!")}
    //                     >
    //                         <svg
    //                             xmlns="http://www.w3.org/2000/svg"
    //                             fill="none"
    //                             viewBox="0 0 24 24"
    //                             strokeWidth="1.5"
    //                             stroke="currentColor"
    //                             className="w-6 h-6"
    //                         >
    //                             <path
    //                                 strokeLinecap="round"
    //                                 strokeLinejoin="round"
    //                                 d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
    //                             />
    //                         </svg>
    //                     </button>
    //                 </div>

    //                 </Row>
    //             </Container>
    //         </div>

            
    //         <div
    //             ref={sidebarRef}
    //             className={`fixed top-0 right-0 h-full w-64 bg-white text-black shadow-lg transform transition-transform duration-300 ease-in-out text-center ${
    //             isOpen ? "translate-x-0" : "translate-x-full"
    //             } z-50`}
    //             style={{ width: "32rem" }}
    //         >
    //             <div className="p-4">
    //             {/* Sidebar Content Based on View */}
    //             {view === "main" ? (
    //                 <>
    //                 <h2 className="text-xl font-bold mb-4">Main Sidebar</h2>
    //                 <p>This is the main content of the sidebar.</p>
    //                 <button
    //                     onClick={showSecondarySidebar}
    //                     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mt-4"
    //                 >
    //                     Go to Secondary View
    //                 </button>
    //                 </>
    //             ) : (
    //                 <>
    //                 <h2 className="text-xl font-bold mb-4">Secondary Sidebar</h2>
    //                 <p>This is the secondary content of the sidebar.</p>
    //                 <button
    //                     onClick={showMainSidebar}
    //                     className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded mt-4"
    //                 >
    //                     Back to Main View
    //                 </button>
    //                 </>
    //             )}
    //             </div>
    //         </div>

    //         <div className="bg-gray-100 shadow-md">
    //             <div className="container mx-auto flex space-x-4 py-4">
    //                 <select className="bg-white p-2 rounded-md shadow-sm">
    //                 <option value="">Filter by Category</option>
    //                 <option value="category1">Category 1</option>
    //                 <option value="category2">Category 2</option>
    //                 <option value="category3">Category 3</option>
    //                 </select>

    //                 <select className="bg-white p-2 rounded-md shadow-sm">
    //                 <option value="">Filter by Price</option>
    //                 <option value="low">Low</option>
    //                 <option value="medium">Medium</option>
    //                 <option value="high">High</option>
    //                 </select>

    //                 {/* <!-- Add more filters as needed --> */}
    //             </div>
    //             </div>

    //             {/* <!-- Your content here --> */}
    //             <div id="content" className="container mx-auto py-6">
    //             {/* <!-- This content will change based on the selected filters --> */}
    //             <div className="grid grid-cols-3 gap-4">
    //                 <div className="item">Item 1</div>
    //                 <div className="item">Item 2</div>
    //                 <div className="item">Item 3</div>
    //                 {/* <!-- More items --> */}
    //             </div>
    //             </div>

    //         <div>
    //             <ContainerWrapper />
    //             <p>This is the userId: {userId}</p>
    //             {/* <Popup /> */}
    //         </div>

    //         {/* <div>
    //             <Container>
    //                 <h2>User Data:</h2>
    //                 <p>This is the userId: {userId}</p>
    //                 {/* Safely access userData properties */}
    //                 {/* <p>Text: {userData.Text || 0}</p> */}
    //                 {/* <p>Calls: {userData.Call || 0}</p> */}
    //                 {/* <p>Emails: {userData['E-mail'] || 0}</p> */}
    //             {/* </Container> */}
    //         {/* </div> */}

    //         <div className="overflow-x-auto">
    //             <table className="table-auto border-collapse border border-gray-300 w-full text-sm text-left">
    //                 <thead className="bg-gray-100">
    //                 <tr>
    //                     <th className="border border-gray-300 px-4 py-2">ID</th>
    //                     <th className="border border-gray-300 px-4 py-2">Name</th>
    //                     <th className="border border-gray-300 px-4 py-2">Email</th>
    //                     <th className="border border-gray-300 px-4 py-2">Role</th>
    //                 </tr>
    //                 </thead>
    //                 {/* <tbody>
    //                 {data.map((row, index) => (
    //                     <tr
    //                     key={row.id}
    //                     className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
    //                     >
    //                     <td className="border border-gray-300 px-4 py-2">{row.id}</td>
    //                     <td className="border border-gray-300 px-4 py-2">{row.name}</td>
    //                     <td className="border border-gray-300 px-4 py-2">{row.email}</td>
    //                     <td className="border border-gray-300 px-4 py-2">{row.role}</td>
    //                     </tr>
    //                 ))}
    //                 </tbody> */}
    //             </table>

    //             <div className="p-4">
    //                 <button
    //                 onClick={toggleSidebar}
    //                 className="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700"
    //                 >
    //                 Open Sidebar
    //                 </button>
    //             </div>


    //             {/* <Popup /> */}
    //         </div>

            

    //         {/* <div>
    //             {error && <p>Error: {error}</p>}

    //             {userData === null ? (
    //                 <p>Loading...</p> // Show loading while userData is being fetched
    //             ) : (
    //                 <div>
    //                     <p>User Data:</p>
    //                     <ul>
    //                         {userData.length > 0 ? (
    //                             userData.map((item, index) => <li key={index}>{item}</li>)
    //                         ) : (
    //                             <p>No data available.</p>
    //                         )}
    //                     </ul>
    //                 </div>
    //             )}
    //         </div> */}
    //     </>
    // );
// }
// Home.jsx
// Home.jsx
import React, { useMemo, useEffect, useState } from "react";
import {
  Phone,
  MessageSquare,
  Mail,
  CalendarDays,
  ListChecks,
  ChevronDown,
  DollarSign,
  UserCheck,
  Building2,
  Download, 
  Loader2
} from "lucide-react";
import { jwtDecode } from "jwt-decode";

import { correlationHeaders } from "@/utils/correlationId";

/* ------------ Config ------------ */
const API_BASE = import.meta.env.VITE_BASE_URL;
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...correlationHeaders(),
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

/* ------------ Auth helpers ------------ */
function getRole() {
    const role = localStorage.getItem("role");
    if (!role) return "Hunter";
  
    const lower = role.toString().trim().toLowerCase();
    if (lower === "farmer") return "Farmer";
    if (lower === "hunter") return "Hunter";
    if (lower === "admin") return "Admin";
    return "Hunter";
  }
  

/* ------------ Targets per role (fallback defaults) ------------ */
const ROLE_TARGETS = {
  Farmer: { callsTotal: 20, dmsTotal: 25, visitTotal: 8 },
  Hunter: { walkInsTotal: 3, meetingsTotal: 3, callsTotal: 10, dmsTotal: 10 },
};

/* ------------ Generic UI atoms ------------ */
const ProgressBar = ({
  value = 0,
  max = 100,
  className = "h-2",
  trackClass = "bg-gray-200",
  barClass = "bg-[#F7E21E]",
}) => {
  const safeMax = Math.max(max || 0, 1);
  const pct = Math.max(0, Math.min(100, (value / safeMax) * 100));
  return (
    <div className={`${className} w-full rounded-full ${trackClass}`}>
      <div
        className={`${className} rounded-full transition-all ${barClass}`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

const StatPill = ({ children, active, disabled }) => (
  <div
    className={[
      "flex h-9 w-9 items-center justify-center rounded-full text-xs font-semibold shadow-sm",
      active ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-600",
      disabled ? "opacity-50" : "",
    ].join(" ")}
  >
    {children}
  </div>
);

/* ------------ Date helpers ------------ */
const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function startOfWeek(date, weekStartsOn = 0) {
  const d = new Date(date);
  const diff = (d.getDay() - weekStartsOn + 7) % 7;
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - diff);
  return d;
}
function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}
function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

/* ------------ Month helpers (PerformanceCard) ------------ */
function ym(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}
function monthLabel(ymStr) {
  const [y, m] = ymStr.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString(undefined, {
    month: "long",
    year: "numeric",
  });
}

/* ------------ Weekly Pills (shared) ------------ */
const WeeklyDatePills = ({
  days,
  selected,
  onSelect,
  todayISO,
  compact = false,
}) => (
  <div
    className={`flex flex-wrap ${
      compact ? "gap-2" : "gap-2 items-center justify-evenly"
    }`}
  >
    {days.map((x) => {
      const isFuture = x.iso > todayISO;
      const isActive = selected === x.iso;
      return (
        <button
          key={x.iso}
          onClick={() => !isFuture && onSelect(x.iso)}
          disabled={isFuture}
          aria-disabled={isFuture}
          title={isFuture ? "Future date" : ""}
          className={[
            "flex flex-col items-center gap-1 focus:outline-none min-w-[2.25rem]",
            isFuture ? "cursor-not-allowed opacity-50" : "cursor-pointer",
          ].join(" ")}
        >
          <StatPill active={isActive} disabled={isFuture}>
            {x.dayNum}
          </StatPill>
          <span className="text-[10px] text-gray-500">{x.label}</span>
        </button>
      );
    })}
  </div>
);

/* ------------ Pipeline Legend/Table (Hunter) ------------ */
const PipelineLegend = () => (
  <div className="flex items-center gap-4 text-xs text-gray-600">
    <span className="flex items-center gap-1">
      <span className="inline-block h-2 w-2 rounded-full bg-yellow-400" /> Active
    </span>
    <span className="flex items-center gap-1">
      <span className="inline-block h-2 w-2 rounded-full bg-orange-400" /> Ongoing
    </span>
    <span className="flex items-center gap-1">
      <span className="inline-block h-2 w-2 rounded-full bg-gray-400" /> Inactive
    </span>
    <span className="flex items-center gap-1">
      <span className="inline-block h-2 w-2 rounded-full bg-gray-600" /> Tanked
    </span>
  </div>
);

function PipelineTable({ rows }) {
  const headers = [
    { color: "bg-yellow-400" },
    { color: "bg-orange-400" },
    { color: "bg-gray-400" },
    { color: "bg-gray-600" },
  ];
  return (
    <div className="overflow-hidden rounded-xl border border-gray-100">
      <table className="w-full border-collapse text-sm">
        <thead className="bg-gray-50 text-left text-xs text-gray-500">
          <tr>
            <th className="px-4 py-3 font-medium">Status</th>
            {headers.map((h, index) => (
              <th key={index} className="px-4 py-3 font-medium text-center">
                <span className={`inline-block h-2 w-2 rounded-full ${h.color}`} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.stage} className="odd:bg-white even:bg-gray-50">
              <td className="px-4 py-3 text-gray-700">{r.stage}</td>
              {r.values.map((v, i) => (
                <td key={i} className="px-4 py-3 text-center text-gray-700">
                  {v}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ------------ Performance Card (shared) ------------ */
function PerformanceCard() {
  const [month, setMonth] = useState(ym(new Date()));
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
const role = (getRole() || '').toLowerCase(); 

  const colors = {
    activations: "bg-[#83DA85]",
    onboardings: "bg-[#32873D]",
    calls: "bg-[#29B6F6]",
    dms: "bg-[#C4E7FF]",
    emails: "bg-[#00658E]",
    walk_ins: "bg-[#ED9812]",
    meetings: "bg-[#FFDDB6]",
    opportunities: "bg-[#F7E21E]",
    dms_emails: "bg-[#C4E7FF]",
    visits: "bg-[#ED9812]",
    default: "bg-gray-900",
  };

  const icons = {
    activations: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWRvbGxhci1zaWduLWljb24gbHVjaWRlLWRvbGxhci1zaWduIj48bGluZSB4MT0iMTIiIHgyPSIxMiIgeTE9IjIiIHkyPSIyMiIvPjxwYXRoIGQ9Ik0xNyA1SDkuNWEzLjUgMy41IDAgMCAwIDAgN2g1YTMuNSAzLjUgMCAwIDEgMCA3SDYiLz48L3N2Zz4=",
    onboardings: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXVzZXItY2hlY2staWNvbiBsdWNpZGUtdXNlci1jaGVjayI+PHBhdGggZD0ibTE2IDExIDIgMiA0LTQiLz48cGF0aCBkPSJNMTYgMjF2LTJhNCA0IDAgMCAwLTQtNEg2YTQgNCAwIDAgMC00IDR2MiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI3IiByPSI0Ii8+PC9zdmc+",
    calls: "/icons/call.svg",
    dms: "/icons/whatsapp.svg",
    emails: "/icons/email.svg",
    walk_ins: "/icons/supervisor_account.svg",
    meetings: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNhbGVuZGFyLWRheXMtaWNvbiBsdWNpZGUtY2FsZW5kYXItZGF5cyI+PHBhdGggZD0iTTggMnY0Ii8+PHBhdGggZD0iTTE2IDJ2NCIvPjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgeD0iMyIgeT0iNCIgcng9IjIiLz48cGF0aCBkPSJNMyAxMGgxOCIvPjxwYXRoIGQ9Ik04IDE0aC4wMSIvPjxwYXRoIGQ9Ik0xMiAxNGguMDEiLz48cGF0aCBkPSJNMTYgMTRoLjAxIi8+PHBhdGggZD0iTTggMThoLjAxIi8+PHBhdGggZD0iTTEyIDE4aC4wMSIvPjxwYXRoIGQ9Ik0xNiAxOGguMDEiLz48L3N2Zz4=",
    opportunities: "data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8bGluZSB4MT0iMTIiIHgyPSIxMiIgeTE9IjIiIHkyPSIyMiIgLz4KICA8cGF0aCBkPSJNMTcgNUg5LjVhMy41IDMuNSAwIDAgMCAwIDdoNWEzLjUgMy41IDAgMCAxIDAgN0g2IiAvPgo8L3N2Zz4K",
    dms_emails: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLW1lc3NhZ2Utc3F1YXJlLWljb24gbHVjaWRlLW1lc3NhZ2Utc3F1YXJlIj48cGF0aCBkPSJNMjIgMTdhMiAyIDAgMCAxLTIgMkg2LjgyOGEyIDIgMCAwIDAtMS40MTQuNTg2bC0yLjIwMiAyLjIwMkEuNzEuNzEgMCAwIDEgMiAyMS4yODZWNWEyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ6Ii8+PC9zdmc+",
    visits: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWJ1aWxkaW5nLWljb24gbHVjaWRlLWJ1aWxkaW5nIj48cGF0aCBkPSJNMTIgMTBoLjAxIi8+PHBhdGggZD0iTTEyIDE0aC4wMSIvPjxwYXRoIGQ9Ik0xMiA2aC4wMSIvPjxwYXRoIGQ9Ik0xNiAxMGguMDEiLz48cGF0aCBkPSJNMTYgMTRoLjAxIi8+PHBhdGggZD0iTTE2IDZoLjAxIi8+PHBhdGggZD0iTTggMTBoLjAxIi8+PHBhdGggZD0iTTggMTRoLjAxIi8+PHBhdGggZD0iTTggNmguMDEiLz48cGF0aCBkPSJNOSAyMnYtM2ExIDEgMCAwIDEgMS0xaDRhMSAxIDAgMCAxIDEgMXYzIi8+PHJlY3QgeD0iNCIgeT0iMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjIwIiByeD0iMiIvPjwvc3ZnPg==",
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/dashboard/performance?month=${month}`, {
          headers: getAuthHeaders(),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const j = await res.json();
        if (!cancelled) setItems(j.items || []);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [month]);

  const monthOptions = (() => {
    const now = new Date();
    return Array.from({ length: 12 }, (_, k) => {
      const d = new Date(now.getFullYear(), now.getMonth() - k, 1);
      return { value: ym(d), label: monthLabel(ym(d)) };
    });
  })();


  const [isDownloading, setIsDownloading] = useState(false);


  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const data = await apiRequest(
        `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.DASHBOARD.PERFORMANCE_DETAILS}?month=${month}&role=${role}`,
        "GET"
      );

      const rows = [["Category", "Sub-category", "Lead ID", "Lead Name", "Date", "Details"]];

      if (role === "farmer" || role === 'admin') {
        const opp = data.opportunities;

        opp.referral_active_special.forEach((r) =>
          rows.push(["Opportunity", "Referral Active/Special", r.lead_id, r.name, r.converted_at, ""])
        );
        opp.referral_fnf.forEach((r) =>
          rows.push(["Opportunity", "Referral F&F", r.lead_id, r.name, r.updated_at, ""])
        );
        opp.financing.forEach((r) =>
          rows.push(["Opportunity", "Financing", r.lead_id, r.name, r.updated_at, ""])
        );
        opp.insurance_products.forEach((r) =>
          rows.push(["Opportunity", "Insurance (Products)", r.lead_id, r.name, r.updated_at, ""])
        );
        opp.insurance_renewal.forEach((r) =>
          rows.push(["Opportunity", "Insurance Renewal", r.lead_id, r.name, r.updated_at, ""])
        );
        data.calls.forEach((r) =>
          rows.push(["Call", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
        data.dms_emails.forEach((r) =>
          rows.push(["DM/Email", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
        data.visits.forEach((r) =>
          rows.push(["Visit", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
      } else if (role === "hunter") {
        data.onboardings.forEach((r) =>
          rows.push(["Onboarding", "", "", "", r.first_kyc_datetime, ""])
        );
        data.activations.forEach((r) =>
          rows.push(["Activation", "", "", "", r.first_transaction_datetime, ""])
        );
        data.meetings.forEach((r) =>
          rows.push(["Meeting", "", r.lead_id, r.name, r.meeting_attend_datetime, ""])
        );
        data.calls.forEach((r) =>
          rows.push(["Call", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
        data.dms.forEach((r) =>
          rows.push(["DM", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
        data.emails.forEach((r) =>
          rows.push(["Email", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
        data.walk_ins.forEach((r) =>
          rows.push(["Walk-in", "", r.lead_id, r.name, r.date_of_interaction, r.notes])
        );
      }

      const csv = rows.map((r) =>
        r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")
      ).join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${role}_performance_${month}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      let errorMessage = "Failed to download performance details";

      if (error?.response?.data) {
        const errorData = error.response.data;
        errorMessage =
          errorData.message ||
          errorData.error ||
          errorData.detail ||
          (typeof errorData === "string" ? errorData : JSON.stringify(errorData)) ||
          errorMessage;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="mx-auto w-full max-w-2xl rounded-2xl border border-gray-100 bg-white p-4 md:p-5 shadow-sm">
      <div className="mb-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-gray-900">My Performance</h3>
        <div className="flex items-center gap-2">
          {/* Month selector */}
          <div className="relative">
            <select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="appearance-none rounded-full border border-gray-200 bg-white px-3 py-1.5 pr-7 text-xs font-medium text-gray-700"
            >
              {monthOptions.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
          </div>

          {/* Download button */}
          <button
            onClick={handleDownload}
            disabled={isDownloading}
            className="flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isDownloading ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <Download className="h-3.5 w-3.5" />
            )}
            {isDownloading ? "Downloading..." : "Download"}
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {items.map((it) => {
          const Icon = icons[it.key] || DollarSign;
          const safeMax = Math.max(it.total || 1, 1);
          const pct = Math.max(0, Math.min(100, (it.done / safeMax) * 100));
          const barColor = colors[it.key] || colors.default;

          return (
            <div key={it.key} className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gray-100">
                <img src={Icon} className='size-7'/>
              </div>

              <div className="w-full">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-semibold text-gray-900">{it.label}</div>
                  <div className="text-[11px] text-gray-500">
                    {it.done}/{it.total}
                  </div>
                </div>

                <div className="mt-2 h-3 w-full rounded-full bg-gray-200">
                  <div className={`h-3 rounded-full ${barColor}`} style={{ width: `${pct}%` }} />
                </div>
              </div>
            </div>
          );
        })}

        {loading && <div className="text-xs text-gray-500">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="text-xs text-gray-500">No data.</div>
        )}
      </div>
    </div>
  );
}

/* ------------ Farmer cards ------------ */
function FarmerMetricRow({ icon, label, sub, value, total }) {
  const safeMax = Math.max(total || 1, 1);
  const pct = Math.max(0, Math.min(100, (value / safeMax) * 100));
  return (
    <div className="flex items-start justify-between">
      <div className="flex items-start gap-2">
        <div className="flex h-5 w-5 items-center justify-center rounded bg-gray-100">
          {icon}
        </div>
        <div className="leading-tight">
          <div className="font-semibold text-gray-900">{label}</div>
          <div className="text-[11px] text-gray-500">{sub}</div>
        </div>
      </div>
      <div className="mt-2 h-2 w-24 rounded-full bg-gray-200">
        <div className="h-2 rounded-full bg-[#F7E21E]" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

function FarmerWeeklyCard({
  days,
  selectedDay,
  setSelectedDay,
  todayISO,
  d,
  daysLeft,
  roleTargets,
  loadingWeekly,
  quarterly,
}) {
  const callsDone = d?.callsDone ?? 0;
  const callsTotal = d?.callsTotal ?? roleTargets.callsTotal;
  const dmsDone = d?.dmsDone ?? 0;
  const dmsTotal = d?.dmsTotal ?? roleTargets.dmsTotal;
  const visitDone = d?.visitDone ?? 0;
  const visitTotal = d?.visitTotal ?? roleTargets.visitTotal;

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-4 md:p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-gray-900">My Weekly Tasks</h3>

      <div className="mb-2 flex flex-wrap gap-2">
        <WeeklyDatePills
          days={days}
          selected={selectedDay}
          onSelect={setSelectedDay}
          todayISO={todayISO}
          compact={true}
        />
      </div>

      <p className="mb-4 text-xs text-gray-500">
        You have {daysLeft} more day{daysLeft === 1 ? "" : "s"} to complete weekly tasks.
      </p>

      <div className="space-y-3 text-[13px] text-gray-800">
        {loadingWeekly ? (
          <>
            <div className="h-5 w-44 rounded bg-gray-200 animate-pulse" />
            <div className="h-5 w-44 rounded bg-gray-200 animate-pulse" />
            <div className="h-5 w-44 rounded bg-gray-200 animate-pulse" />
          </>
        ) : (
          <>
            <FarmerMetricRow
              icon={<Phone className="h-4 w-4 text-gray-700" />}
              label="Calls"
              sub={`${callsDone}/${callsTotal} calls made`}
              value={callsDone}
              total={callsTotal}
            />

            <FarmerMetricRow
              icon={<MessageSquare className="h-4 w-4 text-gray-700" />}
              label="DMs/Emails"
              sub={`${dmsDone}/${dmsTotal} sent`}
              value={dmsDone}
              total={dmsTotal}
            />

            <FarmerMetricRow
              icon={<Building2 className="h-4 w-4 text-gray-700" />}
              label="Visit"
              sub={`${visitDone}/${visitTotal} visits made`}
              value={visitDone}
              total={visitTotal}
            />
          </>
        )}
      </div>

      {/* My Checklist */}
      <div className="mt-6">
        <div className="mb-2 flex items-center justify-between">
          <div className="text-sm font-semibold text-gray-900">My Checklist</div>
        </div>

        {(() => {
          const done = (d.callsDone ?? 0) + (d.dmsDone ?? 0) + (d.visitDone ?? 0);
          const total = (d.callsTotal ?? 0) + (d.dmsTotal ?? 0) + (d.visitTotal ?? 0);
          return (
            <>
              <ProgressBar
                className="h-2"
                value={done}
                max={total}
                trackClass="bg-gray-200"
                barClass="bg-[#F7E21E]"
              />
              <div className="mt-1 text-right text-[11px] text-gray-500">
                {done}/{total} tasks completed
              </div>
            </>
          );
        })()}
      </div>

      {/* Quarterly Opportunities */}
      <div className="mt-6">
        <div className="mb-2 flex items-center justify-between">
          <div className="text-sm font-semibold text-gray-900">Quarterly Opportunities</div>
        </div>
        <ProgressBar
          className="h-2"
          value={quarterly?.done ?? 0}
          max={quarterly?.total ?? 12}
          trackClass="bg-gray-200"
          barClass="bg-[#F7E21E]"
        />
        <div className="mt-1 text-right text-[11px] text-gray-500">
          {(quarterly?.done ?? 0)}/{(quarterly?.total ?? 12)} tasks completed
        </div>
      </div>
    </div>
  );
}

function SummaryRow({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-gray-800">
      <span className="text-[12px] font-medium text-gray-600">{label}</span>
      <span className="text-[13px] font-semibold text-gray-900">{value}</span>
    </div>
  );
}

/**
 * Accounts Summary (Farmer) – now dynamic
 * expecting:
 * {
 *   total_accounts: number,
 *   active_users: number,
 *   active_pct: number
 * }
 */
function FarmerAccountsSummaryCard({ summary }) {
  const total = summary?.total_accounts ?? 0;
  const active = summary?.active_users ?? 0;
  const pct = summary?.active_pct ?? (total ? (active / total) * 100 : 0);

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-gray-900">Accounts Summary</h3>
      <div className="space-y-2 text-sm">
        <SummaryRow label="Total Activated Accounts" value={total} />
        <SummaryRow label="Total Transacting Accounts" value={active} />
        <SummaryRow label="%" value={pct.toFixed(2)} />
      </div>
    </div>
  );
}

/**
 * Monthly Volume & Revenue (Farmer) – now dynamic
 * expecting:
 * {
 *   months: [
 *     { month: "2025-10", volume: 6417432.0, revenue: 53480.0 },
 *     ...
 *   ]
 * }
 */
function FarmerVolumeRevenueCard({ volumeData }) {
    // backend returns an array directly
    const rows = Array.isArray(volumeData) ? volumeData : [];
  
    const fmtRM = (n) => {
      if (n == null) return "-";
      return `RM ${Number(n).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    };
  
    // process_month is like: "2025-11 (November)"
    const fmtMonth = (pm) => {
      if (!pm) return "";
      // take everything before space
      // "2025-11 (November)" -> "2025-11"
      const firstPart = pm.split(" ")[0]; // "2025-11"
      const [yy, mm] = firstPart.split("-").map(Number);
      if (!yy || !mm) return pm;
      const d = new Date(yy, mm - 1, 1);
      return d.toLocaleString(undefined, { month: "long" });
    };
  
    return (
      <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-900">Monthly Volume &amp; Revenue</h3>
        <p className="mt-1 text-[11px] text-gray-500">Comparison with previous month</p>
  
        <div className="mt-4 overflow-hidden rounded-lg border border-gray-200">
          <table className="w-full border-collapse text-xs">
            <thead className="bg-gray-50 text-left text-[11px] text-gray-500">
              <tr>
                <th className="px-3 py-2 font-medium">Month</th>
                <th className="px-3 py-2 font-medium">Volume</th>
                <th className="px-3 py-2 font-medium">Revenue</th>
              </tr>
            </thead>
            <tbody className="bg-white text-[12px] text-gray-800">
              {rows.length === 0 ? (
                <tr>
                  <td className="px-3 py-2" colSpan={3}>
                    No data.
                  </td>
                </tr>
              ) : (
                rows.map((row) => (
                  <tr key={row.process_month} className="border-t border-gray-200">
                    <td className="px-3 py-2">{fmtMonth(row.process_month)}</td>
                    <td className="px-3 py-2">{fmtRM(row.volume)}</td>
                    <td className="px-3 py-2">{fmtRM(row.revenue)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }  

/**
 * Accounts Profile (Farmer) – now dynamic
 * expecting:
 * {
 *   total_profiles: number,
 *   buckets: {
 *     Sexy: [{name, count}],
 *     Normal: [{name, count}],
 *     Ugly: [{name, count}]
 *   }
 * }
 */
function ProfileColumn({ title, items }) {
  return (
    <div>
      <div className="mb-2 text-[11px] font-semibold text-gray-500">{title}</div>
      <ul className="space-y-1">
        {items.map((it) => (
          <li key={it.name} className="flex items-start justify-between">
            <span className="text-gray-800">{it.name}</span>
            <span className="text-gray-500">{it.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function FarmerAccountsProfileCard({ profileData }) {
  const total = profileData?.total_profiles ?? 0;
  const buckets = profileData?.buckets || {};
  const sexy = buckets.Sexy || [];
  const normal = buckets.Normal || [];
  const ugly = buckets.Ugly || [];

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">Accounts Profile</h3>
      <div className="text-[11px] text-gray-500">Total Profiles: {total}</div>

      <div className="mt-4 grid grid-cols-3 gap-6 text-[12px] text-gray-800">
        <ProfileColumn title={<span className="text-lg font-bold underline">Sexy</span>} items={sexy} />
        <ProfileColumn title={<span className="text-lg font-bold underline">Normal</span>} items={normal} />
        <ProfileColumn title={<span className="text-lg font-bold underline">Ugly</span>} items={ugly} />
      </div>
    </div>
  );
}

/* ------------ Hunter Dashboard ------------ */
function ChecklistItem({ icon: Icon, label, data }) {
  const done = data?.done ?? 0;
  const total = data?.total ?? 0;
  return (
    <div className="flex items-center justify-between border-b border-gray-100 py-3 last:border-b-0">
      <div className="flex items-start gap-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100">
          <Icon className="h-4 w-4 text-gray-600" />
        </div>
        <div>
          <div className="text-sm font-semibold text-gray-800">{label}</div>
          <div className="text-xs text-gray-500">
            {done}/{total} {label.toLowerCase()} made
          </div>
        </div>
      </div>
      <div className="w-28">
        <ProgressBar value={done} max={total} className="h-2" />
      </div>
    </div>
  );
}

function HunterDashboard({
  checklist,
  summary,
  pipelineRows,
  d,
  daysLeft,
  err,
  loading,
  days,
  selectedDay,
  setSelectedDay,
  todayISO,
}) {
  const totals = Object.values(checklist).reduce(
    (acc, v) => ({
      done: acc.done + (v?.done || 0),
      total: acc.total + (v?.total || 0),
    }),
    { done: 0, total: 0 }
  );

  return (
    <>
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 md:gap-5 lg:gap-6 lg:grid-cols-3">
        {/* My Daily Checklist */}
        <div className="rounded-2xl border border-gray-100 bg-white p-4 md:p-5 shadow-sm">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-gray-900">My Daily Checklist</h3>
          </div>

          <ProgressBar value={totals.done} max={totals.total || 1} />
          <div className="mt-1 text-right text-[11px] text-gray-500">
            {totals.done}/{totals.total} tasks completed
          </div>

          <div className="mt-2 divide-y divide-gray-100">
            <ChecklistItem icon={Phone} label="Calls" data={checklist.calls} />
            <ChecklistItem icon={MessageSquare} label="DMs" data={checklist.dms} />
            <ChecklistItem icon={Mail} label="Emails" data={checklist.emails} />
          </div>
        </div>

        {/* My Weekly Tasks */}
        <div className="rounded-2xl border border-gray-100 bg-white p-4 md:p-5 shadow-sm">
          <h3 className="mb-4 text-sm font-semibold text-gray-900">My Weekly Tasks</h3>
          <div className="mb-4 flex items-center justify-evenly overflow-x-auto">
            <WeeklyDatePills
              days={days}
              selected={selectedDay}
              onSelect={setSelectedDay}
              todayISO={todayISO}
            />
          </div>
          <p className="text-right text-xs text-gray-500">
            You have {daysLeft} more day{daysLeft === 1 ? "" : "s"} to complete weekly tasks
          </p>

          <div className="mt-4 space-y-3">
            <div className="rounded-lg border border-gray-100 bg-white px-3 py-3">
              <div className="flex items-center justify-between">
                <div className="flex items-start gap-3">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100">
                    <ListChecks className="h-4 w-4 text-gray-600" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800">Walk ins</div>
                    <div className="text-xs text-gray-500">
                      {d.walkInsDone}/{d.walkInsTotal} walk ins made
                    </div>
                  </div>
                </div>
                <div className="w-28">
                  <ProgressBar value={d.walkInsDone} max={d.walkInsTotal} className="h-2" />
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-gray-100 bg-white px-3 py-3">
              <div className="flex items-center justify-between">
                <div className="flex items-start gap-3">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100">
                    <CalendarDays className="h-4 w-4 text-gray-600" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800">Meetings</div>
                    <div className="text-xs text-gray-500">
                      {d.meetingsDone}/{d.meetingsTotal} meetings made
                    </div>
                  </div>
                </div>
                <div className="w-28">
                  <ProgressBar value={d.meetingsDone} max={d.meetingsTotal} className="h-2" />
                </div>
              </div>
            </div>
          </div>

          {err && <div className="mt-3 text-xs text-red-600">Error: {err}</div>}
          {loading && <div className="mt-3 text-xs text-gray-500">Loading…</div>}
        </div>

        {/* Pipeline Summary */}
        <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
          <h3 className="mb-2 text-sm font-semibold text-gray-900">Pipeline Summary</h3>

          {loading ? (
            <div className="text-xs text-gray-500">Loading pipeline data…</div>
          ) : pipelineRows.length === 0 ? (
            <div className="text-xs text-gray-500">No data available.</div>
          ) : (
            <div className="space-y-4">
              <div>
                <div className="mb-2 text-xs font-medium text-gray-700">Leads Generated</div>
                <div className="flex flex-wrap gap-2">
                  {[
                    `Today: ${summary.today ?? 0}`,
                    `This Week: ${summary.week ?? 0}`,
                    `This Month: ${summary.month ?? 0}`,
                  ].map((l) => (
                    <button
                      key={l}
                      className="rounded-full border border-gray-200 px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
                    >
                      {l}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <div className="mb-2 text-xs font-medium text-gray-700">Leads Progress</div>
                <PipelineLegend />
              </div>

              <PipelineTable rows={pipelineRows} />
            </div>
          )}
        </div>
      </div>

      <div className="mx-auto mt-6 max-w-7xl">
        <PerformanceCard />
      </div>
    </>
  );
}

/* ------------ Farmer Dashboard ------------ */
function FarmerDashboard({
  days,
  selectedDay,
  setSelectedDay,
  todayISO,
  d,
  daysLeft,
  roleTargets,
  loadingWeekly,
  quarterly,
  accountsSummary,
  accountsVolume,
  accountsProfile,
}) {
  return (
    <>
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 md:gap-5 lg:gap-6 lg:grid-cols-3">
        <FarmerWeeklyCard
          days={days}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          todayISO={todayISO}
          d={d}
          daysLeft={daysLeft}
          roleTargets={roleTargets}
          loadingWeekly={loadingWeekly}
          quarterly={quarterly}
        />
        <FarmerAccountsSummaryCard summary={accountsSummary} />
        <FarmerVolumeRevenueCard volumeData={accountsVolume} />
      </div>

      <div className="mx-auto mt-4 md:mt-5 lg:mt-6 max-w-7xl">
        <FarmerAccountsProfileCard profileData={accountsProfile} />
      </div>

      <div className="mx-auto mt-4 md:mt-5 lg:mt-6 max-w-7xl">
        <PerformanceCard />
      </div>
    </>
  );
}

/* ------------ Helpers: normalization & cumulative ------------ */
function normalizeWeekData(daysArr, serverMap, role) {
  const T = ROLE_TARGETS[role] || ROLE_TARGETS.Farmer;
  const baseFarmer = {
    callsDone: 0,
    callsTotal: T.callsTotal,
    dmsDone: 0,
    dmsTotal: T.dmsTotal,
    visitDone: 0,
    visitTotal: T.visitTotal,
  };
  const baseHunter = {
    walkInsDone: 0,
    walkInsTotal: T.walkInsTotal,
    meetingsDone: 0,
    meetingsTotal: T.meetingsTotal,
    callsDone: 0,
    callsTotal: T.callsTotal,
    dmsDone: 0,
    dmsTotal: T.dmsTotal,
  };
  const base = role === "Farmer" ? baseFarmer : baseHunter;

  const out = {};
  daysArr.forEach((dObj) => {
    const s = serverMap?.[dObj.iso] || {};
    out[dObj.iso] = { ...base, ...s };
  });
  return out;
}

function makeCumulative(weekMap, role) {
    const keys = Object.keys(weekMap).sort();
    const doneKeys =
      role === "Farmer"
        ? ["callsDone", "dmsDone", "visitDone"]
        : ["walkInsDone", "meetingsDone", "callsDone", "dmsDone"];
  
    const out = {};
  
    keys.forEach((k, idx) => {
      // clone the day object so we don't mutate the input
      const curr = { ...weekMap[k] };
  
      if (idx > 0) {
        const prev = out[keys[idx - 1]];
        doneKeys.forEach((dk) => {
          curr[dk] = (curr[dk] || 0) + (prev[dk] || 0);
        });
      }
  
      out[k] = curr;
    });
  
    return out;
  }  

/* ------------ Page Component (role switcher) ------------ */
export default function Home() {

    const role = getRole();
    const isHybrid = localStorage.getItem("is_hybrid") === "true";
    const effectiveRole = (role === "Admin" || isHybrid) ? "Farmer" : role;

    const roleTargets = ROLE_TARGETS[effectiveRole] || ROLE_TARGETS.Farmer;

    // week scaffold
    const now = useMemo(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);
    const weekStart = useMemo(() => startOfWeek(now, 1), [now]); // Monday
    const days = useMemo(() => {
        return Array.from({ length: 7 }).map((_, i) => {
        const dt = addDays(weekStart, i);
        return {
            date: dt,
            iso: toISODate(dt),
            dayNum: dt.getDate(),
            label: dayLabels[dt.getDay()],
        };
        });
    }, [weekStart]);
    const todayISO = toISODate(now);
    const [selectedDay, setSelectedDay] = useState(todayISO);

    // states
    const [checklist, setChecklist] = useState({
        calls: { done: 0, total: 0 },
        dms: { done: 0, total: 0 },
        emails: { done: 0, total: 0 },
    });
    const [weeklyData, setWeeklyData] = useState({});
    const [weeklyLoading, setWeeklyLoading] = useState(true);
    const [summary, setSummary] = useState({ today: 0, week: 0, month: 0 });
    const [pipelineRows, setPipelineRows] = useState([]);
    const [quarterly, setQuarterly] = useState({ done: 0, total: 12 });

    // new farmer-specific state
    const [accountsSummary, setAccountsSummary] = useState(null);
    const [accountsVolume, setAccountsVolume] = useState(null);
    const [accountsProfile, setAccountsProfile] = useState(null);

    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    // keep selectedDay within this week
    useEffect(() => {
        const valid = days.some((d) => d.iso === selectedDay);
        if (!valid) setSelectedDay(todayISO);
    }, [days, selectedDay, todayISO]);

    useEffect(() => {
        (async () => {
        const resp = await fetch(`${API_BASE}/dashboard/opportunities/quarterly`, {
            headers: getAuthHeaders(),
        });
        if (resp.ok) {
            const j = await resp.json();
            setQuarterly({ done: j.done ?? 0, total: j.total ?? 12 });
        }
        })();
    }, []);

    // fetch dashboard data
    useEffect(() => {
        let cancelled = false;
        async function loadAll() {
        try {
            setLoading(true);
            setErr("");

            // checklist
            const resp1 = await fetch(`${API_BASE}/dashboard/checklist`, {
            headers: getAuthHeaders(),
            });
            if (resp1.ok) {
            const j = await resp1.json();
            if (!cancelled) setChecklist(j);
            }

            // weekly tasks
            setWeeklyLoading(true);
            const weekStartISO = toISODate(weekStart);
            const resp2 = await fetch(
            `${API_BASE}/dashboard/weekly?week_start=${weekStartISO}`,
            { headers: getAuthHeaders() }
            );

            if (resp2.ok) {
            const j = await resp2.json();
            const serverMap = j?.days ?? j ?? {};
            const normalized = normalizeWeekData(days, serverMap, effectiveRole);
            const cumulative = makeCumulative({ ...normalized }, effectiveRole);
            if (!cancelled) setWeeklyData(cumulative);
            } else {
            const fallback = normalizeWeekData(days, {}, effectiveRole);
            const cumulative = makeCumulative({ ...fallback }, effectiveRole);
            if (!cancelled) setWeeklyData(cumulative);
            }
            if (!cancelled) setWeeklyLoading(false);

            // hunter-only endpoints
            if (effectiveRole === "Hunter") {
            const resp3 = await fetch(`${API_BASE}/dashboard/pipeline/summary`, {
                headers: getAuthHeaders(),
            });
            if (resp3.ok) {
                const j = await resp3.json();
                if (!cancelled) setSummary(j);
            }

            const resp4 = await fetch(`${API_BASE}/dashboard/pipeline/table`, {
                headers: getAuthHeaders(),
            });
            if (resp4.ok) {
                const j = await resp4.json();
                if (Array.isArray(j) && !cancelled) setPipelineRows(j);
            }
            } else {
            // farmer-only endpoints
            const s1 = await fetch(`${API_BASE}/dashboard/accounts/summary`, {
                headers: getAuthHeaders(),
            });
            if (s1.ok) {
                const j = await s1.json();
                if (!cancelled) setAccountsSummary(j);
            }

            const s2 = await fetch(`${API_BASE}/dashboard/accounts/volume`, {
                headers: getAuthHeaders(),
            });
            if (s2.ok) {
                const j = await s2.json();
                if (!cancelled) setAccountsVolume(j);
            }

            const s3 = await fetch(`${API_BASE}/dashboard/accounts/profile`, {
                headers: getAuthHeaders(),
            });
            if (s3.ok) {
                const j = await s3.json();
                if (!cancelled) setAccountsProfile(j);
            }
            }
        } catch (e) {
            if (!cancelled) setErr(e?.message || "Failed to load dashboard");
        } finally {
            if (!cancelled) setLoading(false);
        }
        }

        loadAll();
        return () => {
        cancelled = true;
        };
    }, [weekStart, days, effectiveRole]);

    const currentDayData =
        weeklyData?.[selectedDay] ??
        (effectiveRole === "Farmer"
        ? {
            callsDone: 0,
            callsTotal: roleTargets.callsTotal,
            dmsDone: 0,
            dmsTotal: roleTargets.dmsTotal,
            visitDone: 0,
            visitTotal: roleTargets.visitTotal,
            }
        : {
            walkInsDone: 0,
            walkInsTotal: roleTargets.walkInsTotal,
            meetingsDone: 0,
            meetingsTotal: roleTargets.meetingsTotal,
            callsDone: 0,
            callsTotal: roleTargets.callsTotal,
            dmsDone: 0,
            dmsTotal: roleTargets.dmsTotal,
            });

    const dow = now.getDay();              // JS: 0=Sun..6=Sat
    const weekdayIndex = (dow + 6) % 7;    // Our week: 0=Mon..6=Sun
    const daysLeft = Math.max(0, 6 - weekdayIndex);

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 lg:p-8">
        {effectiveRole === "Farmer" ? (
            <FarmerDashboard
            days={days}
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            todayISO={todayISO}
            d={currentDayData}
            daysLeft={daysLeft}
            roleTargets={roleTargets}
            loadingWeekly={weeklyLoading}
            quarterly={quarterly}
            accountsSummary={accountsSummary}
            accountsVolume={accountsVolume}
            accountsProfile={accountsProfile}
            />
        ) : (
            <HunterDashboard
            checklist={checklist}
            summary={summary}
            pipelineRows={pipelineRows}
            d={currentDayData}
            daysLeft={daysLeft}
            err={err}
            loading={loading}
            days={days}
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            todayISO={todayISO}
            />
        )}
        </div>
  );
}
